import { listItemIconClasses } from '@mui/material/ListItemIcon';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiMenu = {
  defaultProps: { disableScrollLock: true },
  styleOverrides: { list: { display: 'flex', flexDirection: 'column', gap: '4px', padding: '8px' } },
} satisfies Components<Theme>['MuiMenu'];

export const MuiMenuItem = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: {
      borderRadius: '8px',
      gap: 'var(--ListItem-gap)',
      paddingBlock: 'var(--MenuItem-paddingBlock, 4px)',
      paddingInline: 'var(--MenuItem-paddingInline, 8px)',
      [`& .${listItemIconClasses.root}`]: { minWidth: 'auto' },
    },
  },
} satisfies Components<Theme>['MuiMenuItem'];
